import PropTypes from 'prop-types';

const graphKeysPropTypes = PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    text: PropTypes.string.isRequired,
}));

export default graphKeysPropTypes;
